import Vue from 'vue';
import accountService from '@/services/account';
import store from '@/store';

// When the request succeeds
const success = ({ id }) => {
  store.dispatch('auth/login', id);
  accountService.decrypt();
  Vue.router.push({
    name: 'home.index',
  });
};

// When the request fails
const failed = () => {
  store.dispatch('general/setMessages', ['Unable to login']);
  return Promise.reject(new Error('Unable to login'));
};

export default (user) => {
  if (!user.username || !user.password) {
    return failed();
  }

  return Vue.$http
    .post('users/login', user)
    .then((response) => {
      success(response.data);
      return response;
    })
    .catch(error => failed(error));
};



// WEBPACK FOOTER //
// ./src/services/auth/login.js